import React, { useState, useEffect } from 'react';
import { Scanner, useDevices } from '@yudiel/react-qr-scanner';
import axios from 'axios';
import Swal from 'sweetalert2';

const App = () => {
  const devices = useDevices();
  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [selectedDeviceId, setSelectedDeviceId] = useState(null);

  // Automatically select the back camera
  useEffect(() => {
    console.log('devices', devices);
    if (devices.length > 0) {
      // const backCamera = devices.find((device) =>
      //   device.label.toLowerCase().includes('back') || device.label.toLowerCase().includes('environment')
      // );
      // if (backCamera) {
      //   setSelectedDeviceId(backCamera.deviceId);
      // } else {
        // Fallback to the first available device if no back camera is found
        setSelectedDeviceId(devices[0].deviceId);
      // }
    }
  }, [devices]);

  const handleScan = async (detectedCodes) => {
    if (detectedCodes.length > 0) {
      const data = detectedCodes[0].rawValue;
      try {
        // Replace with your Strapi endpoint
        const rec = await axios.get(`/api/delegates?filters%5Buid%5D=${data}`);
        const response = await axios.post('/api/check-ins', { data: {
          "checkedAt": new Date(),
          "delegate": rec.data.data[0].id,
        } 
      });

        if (response.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: response.data.message || 'QR code processed successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Failure',
            text: response.data.message || 'Failed to process QR code.',
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'An error occurred while processing the QR code.',
        });
      } finally {
        setIsScannerOpen(false); // Close the scanner after processing
      }
    }
  };

  const handleError = (error) => {
    console.error(error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Error scanning QR code',
    });
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-blue-500 to-purple-600 p-4">
      <h1 className="text-4xl font-bold mb-8 text-white text-center">QR Code Scanner</h1>

      {/* Button to open the scanner */}
      <button
        onClick={() => setIsScannerOpen(true)}
        className="bg-white text-blue-600 font-semibold py-3 px-6 rounded-lg shadow-lg hover:bg-blue-50 transition-all duration-300"
      >
        Open Scanner
      </button>

      {/* Scanner Modal */}
      {isScannerOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
            <h2 className="text-2xl font-bold mb-4 text-center">Scan QR Code</h2>
            {devices.length > 0 ? (
              <div className="relative" style={{ height: '300px', width: '100%' }}>
                {/* Scanner Container */}
                <Scanner
                  onScan={handleScan}
                  onError={handleError}
                  styles={{ container: { height: '100%', width: '100%' } }}
                  components={{ audio: true, torch: true, zoom: true, finder: false }}
                  allowMultiple={true}
                  scanDelay={2000}
                />
              </div>
            ) : (
              <p className="text-red-500 text-center">No camera devices found.</p>
            )}
            {/* Close Scanner Button */}
            <button
              onClick={() => setIsScannerOpen(false)}
              className="mt-4 w-full bg-red-500 text-white py-2 rounded-lg hover:bg-red-600 transition-all duration-300"
            >
              Close Scanner
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;